import { render, staticRenderFns } from "./ModuleDetailedForm.vue?vue&type=template&id=429566c8"
import script from "./ModuleDetailedForm.vue?vue&type=script&lang=js"
export * from "./ModuleDetailedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports